import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../compoment/PortraitStage";

interface UsernameModalProps extends ModalProps {
  onHide: () => void;
  name: string;
  nameErr: string;
  setName: (val: string) => void;
  setNameErr: (val: string) => void;
  handleSubmit: () => void;
}

const UsernameModal = ({
  onHide,
  name,
  setName,
  nameErr,
  setNameErr,
  handleSubmit,
  ...props
}: UsernameModalProps) => {
  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      backdrop="static"
      className="usernameModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div className="otpModalBody">
          <div className="header">
            It seems you haven’t entered <br /> your name yet
          </div>
          <div className="description">
            Your name will appear on the station displays you interacted with.
          </div>
          <div className="text-start">
            <label htmlFor="name">Your name</label>
            <input
              id="name"
              type="text"
              name="name"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                if (e.target.value.trim()) {
                  setNameErr("");
                }
              }}
              placeholder="Enter your name"
              className="form-control"
            />
            {nameErr && <p className="text-danger mt-1">{nameErr}</p>}
          </div>
          <div className="mt-4">
            <button className="btnPrimary w-100" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UsernameModal;
